var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9803 5.98028C15.2732 5.68739 15.2732 5.21251 14.9803 4.91962C14.6874 4.62673 14.2126 4.62673 13.9197 4.91962L9.95001 8.88929L5.98034 4.91962C5.68745 4.62673 5.21258 4.62673 4.91968 4.91962C4.62679 5.21251 4.62679 5.68739 4.91968 5.98028L8.88935 9.94995L4.91968 13.9196C4.62679 14.2125 4.62679 14.6874 4.91968 14.9803C5.21258 15.2732 5.68745 15.2732 5.98034 14.9803L9.95001 11.0106L13.9197 14.9803C14.2126 15.2732 14.6874 15.2732 14.9803 14.9803C15.2732 14.6874 15.2732 14.2125 14.9803 13.9196L11.0107 9.94995L14.9803 5.98028Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseIcon);
export default __webpack_public_path__ + "static/media/icon-close-icon.f6e8b6cf0424dcd97f2fdcd48b106a09.svg";
export { ForwardRef as ReactComponent };